var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #3d75f4;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_5962",
    "data-name": "\\u77E9\\u5F62 5962",
    className: "cls-1",
    width: 20,
    height: 20,
    transform: "translate(982 1115)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248\\u7EC4_3",
    "data-name": "\\u8499\\u7248\\u7EC4 3",
    className: "cls-2",
    transform: "translate(-982 -1115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_45444",
    "data-name": "\\u7EC4 45444",
    transform: "translate(7997 21809.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_537",
    "data-name": "\\u8DEF\\u5F84 537",
    className: "cls-3",
    d: "M.63,4.46A.633.633,0,0,0,0,5.092V11.22a3.755,3.755,0,0,0,3.751,3.751h10.5A3.756,3.756,0,0,0,18,11.22v-6.2a.635.635,0,0,0-.637-.634Z",
    transform: "translate(-7014 -20691.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_538",
    "data-name": "\\u8DEF\\u5F84 538",
    className: "cls-3",
    d: "M14.252,1.5h-4.9l-.351-.084L6.653.237a2.233,2.233,0,0,0-1-.237h-1.9A3.751,3.751,0,0,0,0,3.751v.107a.635.635,0,0,0,.637.634l16.356-.082a.63.63,0,0,0,.575-.9A3.75,3.75,0,0,0,14.252,1.5",
    transform: "translate(-7014 -20692.965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconSelected);
export default __webpack_public_path__ + "static/media/file-icon-selected.ea17171b2b7855458969c9d86bcc4e27.svg";
export { ForwardRef as ReactComponent };